module.exports = __webpack_public_path__ + "static/media/topbanner-our-comp-cigars.c5e41719.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/our-companies-details/topbanner-our-comp-cigars.png
// module id = 352
// module chunks = 0